<template>
    <div>
     <b-modal size="lg" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc 
      :modal-class="'is-draggable'"
      :title="TitleWindow"
      @close="this.emitEventCancel"
      @shown="prepararDrag"
      > 
         <Medications 
            :UseInModal="true" 
            :UseViewAllReadOnly="true" 
            :RecordId="RecordId" 
            :AdmissionRecordId="AdmissionRecordId"
            :PCode="PatientCode"
            >
          </Medications>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="Print">{{$t('Shared.Report')}}</b-button>
        <b-button variant="primary" @click="emitEventCancel">{{$t('Shared.Close')}}</b-button>
      </template>



      <!-- <PatientMedicationsRep v-if="isReportVisible" 
          :closeWindow="closeParamRepWindow"
          :patientCode="this.PatientCode"
          :recNo="RecordId"
          :isControlledSubstance="controlledSubstanceValue"
        />-->
 



     </b-modal>  
    </div>
</template>
 
 <script>
 import ShowMessage from '@/components/messages/ShowMessage.js'
import Medications from '@/components/pages/clinical/medications/Medications';

 
 export default {
   name: 'ModalDrugOrderViewMedication',
    components: { Medications },
   mixins: [ShowMessage],  
   props: {
     ModalId: String,
     TitleWindow: String,    
     ReadOnly:Boolean,
     RecordId:String,
     AdmissionRecordId:String,
     PatientCode:String,
     isControlledSubstance:String,
     isUAE:Boolean,
   },
   
   data(){
     return {
       isReportVisible: false,
     }
   },
 
   methods:{
     emitEventOK(/*bvModalEvent*/){   
     },

     closeParamRepWindow() {
        this.isReportVisible = false
        this.recNoToReport = ''
      },


     Print(bvModalEvent) {
      if(bvModalEvent) bvModalEvent.preventDefault();
      this.$emit('Print', {
        patientCode: this.PatientCode,
        recordId: this.RecordId,
        drugType: this.isControlledSubstance,
        isUAE: this.isUAE
      });
    },

     prepararDrag() {
  this.$nextTick(() => {
    const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
    if (!outer) {
      console.warn("No se encontró el contenedor del modal");
      return;
    }

    const dialog = outer.querySelector(".modal-dialog");
    const header = outer.querySelector(".modal-header");

    if (!dialog || !header) {
      console.warn("No se encontró header o dialog");
      return;
    }

    if (outer.classList.contains("is-draggable")) 
            return;

    header.style.cursor = "move";

    header.onmousedown = (e) => {
      e.preventDefault();

      // Obtener posición actual antes de tocar estilos
      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Fijar posición actual (solo en el primer movimiento)
      dialog.style.width = `${rect.width}px`;
      dialog.style.height = `${rect.height}px`;
      dialog.style.position = "fixed";
      dialog.style.left = `${rect.left}px`;
      dialog.style.top = `${rect.top}px`;
      dialog.style.margin = 0;
      dialog.style.transform = "none";

      const moveHandler = (eMove) => {
        dialog.style.left = `${eMove.clientX - offsetX}px`;
        dialog.style.top = `${eMove.clientY - offsetY}px`;
      };

      document.addEventListener("mousemove", moveHandler);
      document.addEventListener(
        "mouseup",
        () => document.removeEventListener("mousemove", moveHandler),
        { once: true }
      );
    };
  });
},


    /*handleOk() {      
        this.emitEventCancel();
    },*/

    emitEventCancel(){
      this.$emit('OnModalDrugOrderInboxClose');
    },    
   },
 
  mounted(){

   },
 };
 </script>

 <style>

.modal-dialog {
  transition: none !important;
  transform: none !important;
}

.modal-dialog.dragging {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0.98;
  cursor: grabbing !important;
  transition: box-shadow 0.2s ease;
}
.modal-header {
  user-select: none;
}
</style>

